export default "__VITE_ASSET__B_EhK9SP__"